/* eslint-disable max-classes-per-file */
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

abstract class GeoMapAnalyticsEvent extends AnalyticsEvent {
  abstract eventName: string;

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.browse_search;
}

/**
 * # Description
 * Fires when map loads tiles. This occurs when the map loads in, changes location, or is dragged sufficiently far into a new location.
 * - `success`: true/false
 *
 */
export class GeoMapLoadTilesLoadedEvent extends GeoMapAnalyticsEvent {
  eventName = 'map_tiles_loaded';

  constructor(eventProperties: { success: boolean }) {
    super(eventProperties, eventProperties);
  }
}

/**
 * # Description
 * Fires when map encounters an error.
 * - error: error info
 *
 */
export class GeoMapLoadErrorEvent extends GeoMapAnalyticsEvent {
  eventName = 'map_api_load_error';

  constructor(eventProperties: { error: string }) {
    super(eventProperties, eventProperties);
  }
}
